import CompanyUser from 'modules/PlanConfiguration/company-user';

export default function CompanyUserPage() {
  return <CompanyUser />;
}
